import React from "react";
import "./style.scss";
import ButtonComponent from "../button";
import { useNavigate } from "react-router-dom";
import { HomeBannerContent } from "../../pagesContent/homeBannerContent";

export default function Banner() {
  const navigate = useNavigate();
  const handleOnclick = () => {
    navigate("/order");
  };
  return (
    <div className="banner">
      <div className="bannerImg"></div>
      <div className="bannerContent">
        <h1>{HomeBannerContent.bannerHeading}</h1>
        <h2>{HomeBannerContent.bannerSmallText}</h2>
        <h3>{HomeBannerContent.bannerTaglineText}</h3>

        {/* <div className="bannerButtonGroup">
          <ButtonComponent
            text={HomeBannerContent.bannerButtonText}
            type="link"
            handleOnclick={handleOnclick}
          /> */}
          {/* <ButtonComponent text={"Reservations"} type="link" href="/" /> */}
        {/* </div> */}
      </div>
    </div>
  );
}
